import { reactive } from 'vue'

const userId = document.head.querySelector('meta[name="user-id"]');

export const globalStore = reactive({
    userId: userId.getAttribute('content') === '' ? null : userId.getAttribute('content'),
    buyAmount: <number> 0.0,
    sellAmount: <number> 0.0,
    buyTotal: <number> 0.0,
    sellTotal: <number> 0.0,
    buyPrice: <number> 0.0,
    sellPrice: <number> 0.0,
    lastPrice: <number> 0.0
})
